import React from "react";

type Tone = "gray" | "green" | "yellow" | "red" | "blue";

const toneClass: Record<Tone, string> = {
  gray: "bg-surface-alt text-muted border border-surface-border",
  green: "bg-emerald-50 text-emerald-700 border border-emerald-100",
  yellow: "bg-amber-50 text-amber-700 border border-amber-100",
  red: "bg-rose-50 text-rose-700 border border-rose-100",
  blue: "bg-primary/10 text-primary border border-primary/20",
};

export interface StatusBadgeProps {
  label: string;
  tone?: Tone;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ label, tone = "gray" }) => {
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${toneClass[tone]}`}>
      <span className="h-2 w-2 rounded-full bg-current/60" aria-hidden />
      <span className="ml-2">{label}</span>
    </span>
  );
};

export default StatusBadge;
